<template>
    <div v-if="additionals">
        <List
            v-if="additionals.plantaoId"
            :custom-filter="filter"
            :fields="fields"
            :hide-pagination="false"
            :plantao-faixa-etaria-id="additionals.plantaoFaixaEtariaId"
            :setor-tipo-id="enums.setorTipo.ENFERMAGEM"
            @status-tipo-changed="handleStatusTipoChanged"
            ref="Fila"
        >
            <template #filters-bottom>
                <rkm-row class="mb-2">
                    <rkm-col cols="auto">
                        <rkm-form-checkbox v-model="prescricaoInterna">
                            Prescrição interna
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-form-checkbox v-model="examesLaboratoriais">
                            Exames laboratoriais
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-form-checkbox v-model="servicosEnfermagem">
                            Serviços de enfermagem
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:custom-actions="{ item }">
                <rkm-button
                    @click="getAdditionalEnfermagemData(item.atendimento.id)
                        .then(data => $refs.ModalInfo.open(getInfoParams(item, data)))"
                    color="outline-secondary"
                    small
                    title="Informações"
                >
                    <rkm-icon icon="info" />
                </rkm-button>

                <rkm-button
                    @click="answer(item)"
                    color="primary"
                    small
                    title="Atender"
                    authorize="store-pronto-atendimento-atendimento-enfermagem"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <rkm-button
                    color="info"
                    small
                    title="Imprimir"
                    @click="getImpressoes(item.atendimento.id, enums.setorTipo.ENFERMAGEM)
                        .then(impressoes => $refs.ModalImpressao.open(impressoes, item.atendimento.id))"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEvasao.open(item.id)"
                    color="danger"
                    small
                    title="Evadir"
                >
                    <rkm-icon icon="running" />
                </rkm-button>

            </template>
        </List>

        <rkm-alert color="warning" v-else>
            Não existe nenhum plantão cadastrado para este usuário.
        </rkm-alert>

        <ModalEvasao ref="ModalEvasao" />
        <ModalImpressao ref="ModalImpressao" :plantao-id="model.currentPlantaoId" />
        <ModalInfo ref="ModalInfo" show-box-if-empty />
    </div>
</template>

<script>
import { prontoAtendimentoFila } from '@/mixins'

import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'
import ModalInfo from './components/informacao/Modal.vue'

import tipoSetor from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    components: { ModalImpressao, ModalInfo },
    created() {
        this.repositories.enfermagem = this.getConectaSusRepository('prontoAtendimento.enfermagem')
    },
    data: () => ({
        additionals: null,
        createRouteName: 'pronto-atendimento-atendimento-enfermagem-create',
        prescricaoInterna: false,
        examesLaboratoriais: false,
        servicosEnfermagem: false,
        enums: { tipoSetor },
        repositories: {
            enfermagem: null,
        },
    }),
    methods: {
        filter(fila) {

            return fila.filter(f => (!this.prescricaoInterna && !this.examesLaboratoriais && !this.servicosEnfermagem)
                || (this.prescricaoInterna && f.atendimento.prescricoesInternas.length > 0)
                || (this.examesLaboratoriais && f.atendimento.examesLaboratoriais.length > 0)
                || (this.servicosEnfermagem && (f.lastFilaSetorTipoId === this.enums.tipoSetor.RECEPCAO
                        || f.atendimento.servicosEnfermagem.length > 0
                        || f.atendimento.observacoesEnfermagem.length > 0
                    ))
            )
        },
        getInfoParams(item, data) {

            const params = {}

            if (item.lastFilaSetorTipoId === this.enums.tipoSetor.RECEPCAO) {

                params.motivoAtendimento = item.atendimento.recepcao.motivoAtendimento
            }

            if ([this.enums.tipoSetor.CONSULTORIO, this.enums.tipoSetor.EXAMES].includes(item.lastFilaSetorTipoId)) {

                params.servicosEnfermagem = data.servicosEnfermagem
                params.observacoesEnfermagem = data.observacoesEnfermagem
                params.prescricoesInternas = data.prescricoesInternas
                params.examesLaboratoriais = data.examesLaboratoriais
            }

            return params
        },
        load() {
            this.repositories.enfermagem.index()
                .then(response => {
                    this.additionals = response.data.additionals
                    this.model.currentPlantaoId = this.additionals.plantaoId
                })
                .catch(this.handleError)
        },
    },
    mixins: [ error, prontoAtendimentoFila, repository ],
    mounted() {
        this.load()
    },
}
</script>